import {
  IndustryDetails,
  SectorDetails,
  SectorIndustry,
} from "../models/industry-page.model";
import * as SectorIndustryActions from "../actions/sector-industry.actions";
import { Dictionary } from "../models/common_types";

const initialState: SectorIndustry = {
  hasData: false,
  error: false,
  hasCompaniesData: false,
  hasSubHeaderData: false,
  subHeaderData: {
    geographies: [],
    marketCaps: [],
    subGroups: [],
  },
  selectedIndustryId: "",
  selectedSectorName: "",
  selectedSectorId: "",
  selectedIndustryName: "",
  industryMap: {},
  sectorMap: {},
  allGeography: null,
  popularGeography: [],
  otherGeographies: [],
  popularSelected: new Set(),
  otherSelected: {
    countries: new Set(),
    regions: new Set(),
  },
  marketCaps: [],
  selectedMarketCaps: [],
  clusters: [],
  selectedCluster: null,
  selectedCompanyCount: 0,
  reloadAll: false,
  facetSelectionSettings: undefined,
  isIndustryMegaMenuVisible: false,
};

export function sectorIndustryReducer(
  state: SectorIndustry = initialState,
  action: SectorIndustryActions.Actions,
) {
  const sectorMap: Dictionary<SectorDetails> = {};
  const industryMap: Dictionary<IndustryDetails> = {};
  let selectedSectorId = "";
  let selectedIndustryName = "";
  switch (action.type) {
    case SectorIndustryActions.SET_SECTOR_INDUSTRY:
      action.payload.sectors.sectors.forEach((_sector) => {
        sectorMap[_sector.sector_id] = {
          count: 0,
          sectorId: _sector.sector_id.toString(),
          sectorName: _sector.sector_name,
          vaCompsAccessible: false,
          industryIds: [],
        };
      });

      action.payload.industries.forEach((_industry) => {
        const industryIds = [];
        _industry.industry_list.forEach((ind) => {
          const _ind = { ...ind };
          if (_ind.industry_id.toString() === action.payload.industryId) {
            selectedSectorId = _industry.sector_id.toString();
            selectedIndustryName = _ind.industry_name;
          }
          industryIds.push(_ind.industry_id.toString());
          _ind["industryId"] = _ind.industry_id;
          _ind["sectorId"] = _industry.sector_id;
          industryMap[_ind.industry_id] = {
            coveredCompaniesCount: _ind.covered_companies_count,
            industryName: _ind.industry_name,
            compGroupCount: _ind.comp_group_count,
            industryId: _ind.industry_id.toString(),
            sectorId: _industry.sector_id,
            tabId: _ind.tab_id,
          };
          ind = { ..._ind };
        });

        sectorMap[_industry.sector_id].industryIds = industryIds;
        sectorMap[_industry.sector_id].count = _industry.count;
      });

      return {
        ...state,
        industryMap: industryMap,
        sectorMap: sectorMap,
        hasData: true,
        selectedSectorId: selectedSectorId,
        selectedSectorName: sectorMap[selectedSectorId].sectorName,
        selectedIndustryId: action.payload.industryId,
        selectedIndustryName: selectedIndustryName,
        selectedCluster:
          action.payload.selectedCluster || state.selectedCluster,
      };

    case SectorIndustryActions.CHANGE_SECTOR_INDUSTRY:
      selectedSectorId =
        state.industryMap[action.payload.selectedIndustryId].sectorId;
      return {
        ...state,
        hasCompaniesData: action.payload.hasCompaniesData || false,
        selectedIndustryId: action.payload.selectedIndustryId,
        selectedSectorId: selectedSectorId,
        selectedSectorName: state.sectorMap[selectedSectorId].sectorName,
        selectedIndustryName:
          state.industryMap[action.payload.selectedIndustryId].industryName,
        selectedCluster:
          action.payload.selectedCluster || state.selectedCluster,
      };
    case SectorIndustryActions.SET_RELOAD_ALL:
      return {
        ...state,
        reloadAll: action.payload.reloadAll,
        facetSelectionSettings: action.payload.facetSelectionSettings,
      };
    case SectorIndustryActions.SET_CLUSTER_DATA:
      return {
        ...state,
        hasCompaniesData: true,
        reloadAll: false,
        error: action.payload.error,
        allGeography: action.payload.allGeography,
        popularGeography: action.payload.popularGeography,
        otherGeographies: action.payload.otherGeographies,
        popularSelected: action.payload.popularSelected,
        otherSelected: action.payload.otherSelected,
        marketCaps: action.payload.marketCaps,
        selectedMarketCaps: action.payload.selectedMarketCaps,
        clusters: action.payload.clusters,
        selectedCluster: action.payload.selectedCluster,
        selectedCompanyCount: action.payload.selectedCompanyCount,
        facetSelectionSettings: action.payload.facetSelectionSettings,
      };
    case SectorIndustryActions.SET_INDUSTRY_SUB_HEADER:
      return {
        ...state,
        hasSubHeaderData: true,
        subHeaderData: action.payload.data,
        selectedCluster: action.payload.selectedCluster,
      };
    case SectorIndustryActions.SET_INDUSTRY_MEGAMENU_VISIBILITY:
      return {
        ...state,
        isIndustryMegaMenuVisible: action.payload.isIndustryMegaMenuVisible,
      };
    case SectorIndustryActions.CHANGE_SECTOR_INDUSTRY_AND_SET_CLUSTER_DATA:
      selectedSectorId =
        state.industryMap[action.payload.selectedIndustryId].sectorId;
      return {
        ...state,
        hasCompaniesData: true,
        selectedIndustryId: action.payload.selectedIndustryId,
        selectedSectorId: selectedSectorId,
        selectedSectorName: state.sectorMap[selectedSectorId].sectorName,
        selectedIndustryName:
          state.industryMap[action.payload.selectedIndustryId].industryName,
        reloadAll: false,
        error: action.payload.error,
        allGeography: action.payload.allGeography,
        popularGeography: action.payload.popularGeography,
        otherGeographies: action.payload.otherGeographies,
        popularSelected: action.payload.popularSelected,
        otherSelected: action.payload.otherSelected,
        marketCaps: action.payload.marketCaps,
        selectedMarketCaps: action.payload.selectedMarketCaps,
        clusters: action.payload.clusters,
        selectedCluster: action.payload.selectedCluster,
        selectedCompanyCount: action.payload.selectedCompanyCount,
        facetSelectionSettings: action.payload.facetSelectionSettings,
      };
    case SectorIndustryActions.RESET_SECTOR_INDUSTRY_DATA:
      return {
        ...state,
        hasData: false,
        error: false,
        hasCompaniesData: false,
        hasSubHeaderData: false,
        subHeaderData: {
          geographies: [],
          marketCaps: [],
          subGroups: [],
        },
        selectedIndustryId: "",
        selectedSectorName: "",
        selectedSectorId: "",
        selectedIndustryName: "",
        industryMap: {},
        sectorMap: {},
        allGeography: null,
        popularGeography: [],
        otherGeographies: [],
        popularSelected: new Set(),
        otherSelected: {
          countries: new Set(),
          regions: new Set(),
        },
        marketCaps: [],
        selectedMarketCaps: [],
        clusters: [],
        selectedCluster: null,
        selectedCompanyCount: 0,
        reloadAll: false,
        facetSelectionSettings: undefined,
      };
    default:
      return state;
  }
}
